import { OrderDirection } from "@/constants/orderDirection";
import { z } from "zod";
import { IndividualTabKey, OperatorTabKey, SortColumns } from "./-constants";

export const OperatorSearchSchema = z.object({
  orderDirection: z
    .nativeEnum(OrderDirection)
    .default(OrderDirection.ASC)
    .optional(),
  sortColumn: z.enum(SortColumns).optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  category: z
    .nativeEnum(OperatorTabKey)
    .default(OperatorTabKey.OPERATOR_MEMBERSHIP),
  freeText: z.string().optional(),
});

export type OperatorSearchSchema = z.infer<typeof OperatorSearchSchema>;

export const IndividualSearchSchema = z.object({
  orderDirection: z
    .nativeEnum(OrderDirection)
    .default(OrderDirection.ASC)
    .optional(),
  sortColumn: z.enum(SortColumns).optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  category: z
    .nativeEnum(IndividualTabKey)
    .default(IndividualTabKey.INDIVIDUAL_MEMBERSHIP),
  freeText: z.string().optional(),
});

export type IndividualSearchSchema = z.infer<typeof IndividualSearchSchema>;
